import { RRule } from 'rrule';
import { DatePickerValue } from '../../components/date-picker';
import { toSchultzDate } from './utils';

export function calculateDates(startDate: DatePickerValue, endDate: DatePickerValue, weekdays: string[]): Date[] {
  if (endDate && startDate) {
    const correctStartDate = toSchultzDate(startDate);
    const correctStartEnd = toSchultzDate(endDate);
    const selectedWeekdays = getRRuleWeekdays(weekdays);

    const rule = new RRule({
      freq: RRule.WEEKLY,
      byweekday: selectedWeekdays,
      dtstart: toUTCMidnight(correctStartDate),
      until: toUTCMidnight(correctStartEnd),
    });

    return rule.all();
  }
  return [];
}

function getRRuleWeekday(weekday: string) {
  let weekdayResult;
  switch (weekday) {
    case 'monday':
      weekdayResult = RRule.MO;
      break;
    case 'tuesday':
      weekdayResult = RRule.TU;
      break;
    case 'wednesday':
      weekdayResult = RRule.WE;
      break;
    case 'thursday':
      weekdayResult = RRule.TH;
      break;
    case 'friday':
      weekdayResult = RRule.FR;
      break;
    default:
      throw new Error('Unknown weekday');
  }

  return weekdayResult;
}

function getRRuleWeekdays(weekdays: string[]) {
  return weekdays.map(x => getRRuleWeekday(x));
}

function toUTCMidnight(localDate: Date): Date {
  return new Date(Date.UTC(localDate.getFullYear(), localDate.getMonth(), localDate.getDate(), 0, 0, 0, 0));
}
